import React, { useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import { FaHourglassHalf } from "react-icons/fa6";
import { useDropzone } from 'react-dropzone';
import { bannerName } from '../../services/profile';
import { save } from '../../services/stacks';
import './style.scss';
import { getUserData } from '../../services/auth';

const appOrigin = window.location.origin;

function BannerUpload({
    self,
    storageUrl,
    setBannerUrl,
    setErrorMsg,
    setOpenSnackBar,
    setShowBannerUpload,
    setShowUserContractDeployModal,
    validating,
}) {
    const [isSaving, setIsSaving] = useState(false);

    const handleOpen = () => {
        if (storageUrl === undefined) {
            validating(setShowUserContractDeployModal, true);
        } else if ((storageUrl === 'default') || (storageUrl !== getUserData()?.profile?.apps[appOrigin])) {
            setShowBannerUpload(true);
        } else {
            open();
        }
    };

    const onDrop = (acceptedFiles, rejectedFiles) => {
        setIsSaving(true);
        if (rejectedFiles.length > 0) {
            setErrorMsg({
                msg: `Error: Banner should be a PNG file under 2MB`,
                reason: 'error',
            });
            setIsSaving(false);
            setOpenSnackBar(true);
            return;
        }

        const file = acceptedFiles[0];
        const image = new Image();
        image.onload = async () => {
            if (image.width === 1500 && image.height === 500) {
                const content = file;
                console.log({ bannerName });
                save({ content, fileName: bannerName }, { encrypt: false }).then(({ result: url, success }) => {
                    if (success) {
                        setBannerUrl(url);
                        setErrorMsg({ msg: `Banner uploaded successfully`, reason: 'success' });
                    } else {
                        setErrorMsg({ msg: `Error:  Banner upload failed`, reason: 'error' });
                    }
                    if (rejectedFiles.length > 0) {
                        setErrorMsg({ msg: `Error: Banner should be .PNG`, reason: 'error' });
                    }
                    setOpenSnackBar(true);
                    setIsSaving(false);
                });
            } else {
                setErrorMsg({ msg: `Banner should be 1500 x 500 px`, reason: 'warning' });
                setOpenSnackBar(true);
            }
        };
        image.onerror = () => {
            setErrorMsg({ msg: `Error loading image`, reason: 'error' });
            setOpenSnackBar(true);
        };
        image.src = URL.createObjectURL(file);
    };

    const { getInputProps, open } = useDropzone({
        noClick: true,
        noKeyboard: true,
        onDrop,
        accept: { 'image/png': ['.png'] },
        maxFiles: 1,
        maxSize: 2097152, // 2MB
    });

    return (
        <>
            {self && (
                <button id="upload-button" onClick={handleOpen} disabled={isSaving}>
                    <input hidden {...getInputProps()} />
                    {isSaving ? <FaHourglassHalf id="bannerBtnIcon" fontSize="large" /> : <FiUpload id="bannerBtnIcon" fontSize="large" />}
                </button>
            )}
        </>
    );
}

export default BannerUpload;
